import * as z from 'zod'
import { keysToCamel } from '~/utility/toCamel'
import { langFallback$Fetch } from '../../../lang/utils/langfetch'
import { BookingStatusParams, bookingStatusZ } from './schema'

/* eslint-disable @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access,
   @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-return --
   TODO: Properly type API response before Zod parsing */
export class BookingStatusServiceFetch {
  async get({ taskId }: BookingStatusParams, langCode: string) {
    const response = await langFallback$Fetch(langCode, `/pucelery/${taskId}`, {
      timeout: 15000,
    })
    return bookingStatusZ
      .extend({
        result: z.union([bookingStatusZ.shape.result, z.string()]),
      })
      .transform(bookingStatusZ, (v) => {
        if (typeof v.result === 'string') {
          v = { ...v, result: { error: v.result } }
        }
        if (!bookingStatusZ.check(v)) {
          throw new Error('no v')
        }
        return v
      })
      .parse(keysToCamel(response))
  }
}
